<template>
  <div>
    <app-nav :full-name="userFullName"/>
    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <div class="columns">
          <div class="column is-four-fifths">
            <form @submit.prevent="searchFactory">
              <b-field>
                <b-input
                  ref="factoryCodeInput"
                  v-model="factoryCodeSearch"
                  expanded
                  placeholder="Search a factory code ..."
                  type="search"
                  icon="magnify" />
                <p class="control">
                  <button
                    type="submit"
                    class="button is-primary">Search</button>
                </p>
              </b-field>
            </form>
          </div>

          <div class="column is-one-fifth">

            <router-link
              to="/factory"
              class="button is-link is-outlined">
              <b-icon
                icon="plus" />
              <span>Create new factory</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="column" />
    </div>

    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <b-table
          ref="mainTable"
          :data="overviews"
          :per-page="itemsPerPage"
          paginated
          pagination-size="is-small">

          <template slot-scope="props">
            <b-table-column
              field="factoryCode"
              label="Factory code"
              sortable>
              <router-link :to="'/factories/' + props.row.factoryCode">{{ props.row.factoryCode }}</router-link>
            </b-table-column>

            <b-table-column
              field="factoryName"
              label="Factory name">
              {{ props.row.factoryName }}
            </b-table-column>

            <b-table-column
              label="Actions">
              <router-link
                :to="'/factories/' + props.row.factoryCode"
                class="has-text-primary">edit</router-link> |
              <router-link
                :to="'/factories/' + props.row.factoryCode + '/articles'"
                class="has-text-link">articles</router-link>
            </b-table-column>
          </template>

          <template slot="bottom-left">
            <b-select
              v-model="itemsPerPage"
              size="is-small"
              required>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </b-select>
          </template>

        </b-table>
      </div>
      <div class="column"/>
    </div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { getFactoriesOverview } from '../utils/api'

export default {
  name: 'factories-overview',
  components: {
    AppNav
  },
  data() {
    return {
      overviews: [],
      userFullName: '',
      factoryCodeSearch: '',
      // loading
      isLoading: false,
      // table elements
      itemsPerPage: 20
    }
  },
  created() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.isLoading = true
        self.getFactoriesOverview()
        self.userFullName = JSON.parse(getUser()).fullName
        self.isLoading = false
        self.$refs.factoryCodeInput.focus()
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getFactoriesOverview() {
      getFactoriesOverview().then((overviews) => {
        this.overviews = overviews
      })
    },
    searchFactory() {
      this.$router.push(`/factories/${this.factoryCodeSearch}`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smaller {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/FactoriesOverview.vue